import Cookies from 'js-cookie';
import { useContext, useEffect, useState } from 'react';
import constants from '../../../../constants/constants';
import { Button, Card, Input, Radio, Select, Table, Tabs, Tooltip } from 'antd';
import APIUtils from '../../../../api/APIUtils';
import WebLinks from '../../../../api/WebLinks';
import * as XLSX from "xlsx";
import { FileExcelOutlined } from "@ant-design/icons";
import { CommonContext } from '../../../../Context';
const { Search } = Input;

const SpendData = () => {
  const [loader, setLoader] = useState({});
  const [searchText, setSearchText] = useState("");
  const [selectedDays, setSelectedDays] = useState(90);
  const [downloadLoading, setDownloadLoading] = useState({});
  const [mainTab, setMainTab] = useState("highSpend");
  const [typeFilter, setTypeFilter] = useState("all");
  const [status, setStatus] = useState("live");
  const [activeKeys, setActiveKeys] = useState([]);
  const [multiData, setMultiData] = useState({});
  const [paginationState, setPaginationState] = useState({});
  const commonContext=useContext(CommonContext);
  const buyerId = commonContext.common.buyerId;

  const TAB_CONFIG = {
    [constants.liveJobsLowAppVolume]: {
      label: constants.LiveJobsLowAppVolume,
      apiRoute: WebLinks.GetMultiSpendDataLowJobsLive,
      columns: ["jobTitle", "city", "apps"],
    },
    [constants.expiredJobsLowAppVolume]: {
      label: constants.ExpiredJobsLowAppVolume,
      apiRoute: WebLinks.GetMultiSpendDataLowJobsExpired,
      columns: ["jobTitle", "city", "apps"],
      hasDaysFilter: true,
    },
    [constants.liveJobTitlesLowAppVolume]: {
      label: constants.LiveJobTitlesLowAppVolume,
      apiRoute: WebLinks.GetMultiSpendDataLowJobsLiveTitles,
      columns: ["jobTitle", "apps"],
    },
    [constants.liveLocationsLowAppVolume]: {
      label: constants.LiveLocationsLowAppVolume,
      apiRoute: WebLinks.GetMultiSpendDataLowJobsLiveLocations,
      columns: ["jobLocation", "apps"],
    },
    [constants.expiredJobTitlesLowAppVolume]: {
      label: constants.ExpiredJobTitlesLowAppVolume,
      apiRoute: WebLinks.GetMultiSpendDataLowJobsExpiredTitles,
      columns: ["jobTitle", "apps"],
      hasDaysFilter: true,
    },
    [constants.expiredLocationsLowAppVolume]: {
      label: constants.ExpiredLocationsLowAppVolume,
      apiRoute: WebLinks.GetMultiSpendDataLowJobsExpiredLocations,
      columns: ["location", "apps"],
      hasDaysFilter: true,
    },
    [constants.liveJobsHighSpend]: {
      label: constants.LiveJobsHighSpend,
      apiRoute: WebLinks.GetMultiSpendDataHighJobsLive,
      columns: ["jobTitle", "city", "apps", "spend"],
    },
    [constants.expiredJobsHighSpend]: {
      label: constants.ExpiredJobsHighSpend,
      apiRoute: WebLinks.GetMultiSpendDataHighJobsExpired,
      columns: ["jobTitle", "city", "apps", "spend"],
      hasDaysFilter: true,
    },
    [constants.liveJobTitlesHighSpend]: {
      label: constants.LiveJobTitlesHighSpend,
      apiRoute: WebLinks.GetMultiSpendDataHighJobsLiveTitles,
      columns: ["jobTitle", "apps", "spend"],
    },
    [constants.liveLocationsHighSpend]: {
      label: constants.LiveLocationsHighSpend,
      apiRoute: WebLinks.GetMultiSpendDataHighJobsLiveLocations,
      columns: ["jobLocation", "apps", "spend"],
    },
    [constants.expiredJobTitlesHighSpend]: {
      label: constants.ExpiredJobTitlesHighSpend,
      apiRoute: WebLinks.GetMultiSpendDataHighJobsExpiredTitles,
      columns: ["jobTitle", "apps", "spend"],
      hasDaysFilter: true,
    },
    [constants.expiredLocationsHighSpend]: {
      label: constants.ExpiredLocationsHighSpend,
      apiRoute: WebLinks.GetMultiSpendDataHighJobsExpiredLocations,
      columns: ["city", "apps", "spend"],
      hasDaysFilter: true,
    },
  };

  const getKeysByFilters = () => {
    const map = {
      lowVolume: {
        live: {
          jobs: [
            constants.liveJobsLowAppVolume,
            constants.liveJobTitlesLowAppVolume,
          ],
          locations: [constants.liveLocationsLowAppVolume],
          all: [
            constants.liveJobsLowAppVolume,
            constants.liveJobTitlesLowAppVolume,
            constants.liveLocationsLowAppVolume,
          ],
        },
        expired: {
          jobs: [
            constants.expiredJobsLowAppVolume,
            constants.expiredJobTitlesLowAppVolume,
          ],
          locations: [constants.expiredLocationsLowAppVolume],
          all: [
            constants.expiredJobsLowAppVolume,
            constants.expiredJobTitlesLowAppVolume,
            constants.expiredLocationsLowAppVolume,
          ],
        },
      },
      highSpend: {
        live: {
          jobs: [
            constants.liveJobsHighSpend,
            constants.liveJobTitlesHighSpend,
          ],
          locations: [constants.liveLocationsHighSpend],
          all: [
            constants.liveJobsHighSpend,
            constants.liveJobTitlesHighSpend,
            constants.liveLocationsHighSpend,
          ],
        },
        expired: {
          jobs: [
            constants.expiredJobsHighSpend,
            constants.expiredJobTitlesHighSpend,
          ],
          locations: [constants.expiredLocationsHighSpend],
          all: [
            constants.expiredJobsHighSpend,
            constants.expiredJobTitlesHighSpend,
            constants.expiredLocationsHighSpend,
          ],
        },
      },
    };
    return map[mainTab][status][typeFilter];
  };

  useEffect(() => {
    setActiveKeys(getKeysByFilters());
  }, [mainTab, status, typeFilter]);

  const fetchAllTables = async (triggerType = "all") => {
    const keys = getKeysByFilters();
    const filteredKeys =
      triggerType === "days"
        ? keys.filter((key) => TAB_CONFIG[key]?.hasDaysFilter)
        : keys;
    if (!filteredKeys.length) return;

    const loadingState = {};
    filteredKeys.forEach((key) => (loadingState[key] = true));
    setLoader((prev) => ({ ...prev, ...loadingState }));
    filteredKeys.forEach(async (key) => {
      try {
        let params = `buyerId=${buyerId}`;
        if (TAB_CONFIG[key]?.hasDaysFilter) {
          params += `&days=${selectedDays}`;
        }
        const url = `${TAB_CONFIG[key].apiRoute}?${params}`;
        const res = await APIUtils.apiCall("GET", url);
        const data =
          !res.isCatch && res.resultObj.statusCode === "2000"
            ? res.resultObj.data || []
            : [];
        setMultiData((prev) => ({
          ...prev,
          [key]: data,
        }));
      } catch {
        setMultiData((prev) => ({
          ...prev,
          [key]: [],
        }));
      } finally {
        setLoader((prev) => ({
          ...prev,
          [key]: false,
        }));
      }
    });
  };

  useEffect(() => {
    if (!buyerId) return;

    fetchAllTables("all");
  }, [buyerId, mainTab, status, typeFilter]);

  useEffect(() => {
    if (!buyerId) return;

    fetchAllTables("days");
  }, [selectedDays]);

  const downloadFile = async (key) => {
    try {
      setDownloadLoading((prev) => ({ ...prev, [key]: true }));
      const config = TAB_CONFIG[key];
      const data = multiData[key] || [];
      const formatted = data.map((item) => {
        const row = {};
        config.columns.forEach((colKey) => {
          const col = commonColumns[colKey];
          row[col.title] = item[col.dataIndex];
        });
        return row;
      });
      const ws = XLSX.utils.json_to_sheet(formatted);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Data");
      XLSX.writeFile(wb, `${config.label}.xlsx`);
    } catch (err) {
      console.error(err);
    } finally {
      setDownloadLoading((prev) => ({ ...prev, [key]: false }));
    }
  };
  // Function to open job details in new tab
  const openJobDetails = (jobId) => {
    window.open(`https://www.applygateway.com/apply?JobId=${jobId}`, "_blank");
  };
  const commonColumns = {
    jobTitle: {
      title: "Jobtitle",
      dataIndex: "jobtitle",
      ellipsis:true,
      key: "jobtitle",
      width: 220,
      render: (text, record) => {
        const hasId = !!record?.id;
        return (
          <span
            className={`block truncate ${hasId ? "cursor-pointer hover:underline hover:text-blue-600" : ""}`}
            title={text}
            onClick={() => hasId && openJobDetails(record.id)}
          >
            {text}
          </span>
        );
      },
      sorter: (a, b) => (a.jobtitle || "").localeCompare(b.jobtitle || ""),
      sortDirections: ["ascend", "descend"],
    },
    city: {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 140,
      sorter: (a, b) => (a.city || "").localeCompare(b.city || ""),
      sortDirections: ["ascend", "descend"],
    },
    location: {
      title: "Location",
      dataIndex: "city",
      key: "city",
      width: 140,
      sorter: (a, b) => (a.city || "").localeCompare(b.city || ""),
      sortDirections: ["ascend", "descend"],
    },
    jobLocation: {
      title: "Joblocation",
      dataIndex: "joblocation",
      key: "joblocation",
      width: 180,
      sorter: (a, b) => (a.joblocation || "").localeCompare(b.joblocation || ""),
      sortDirections: ["ascend", "descend"],
    },
    apps: {
      title: "Apps",
      dataIndex: "apps",
      key: "apps",
      width: 100,
      align:"right",
      sorter: (a, b) => (a.apps || 0) - (b.apps || 0),
      sortDirections: ["ascend", "descend"],
    },
    spend: {
      title: "Spend",
      dataIndex: "spend",
      key: "spend",
      width: 120,
      align:"right",
      render: (value) => {
        const num = Number(value) || 0;
        return `£${num.toFixed(2)}`;
      },
      sorter: (a, b) => (a.spend || 0) - (b.spend || 0),
      sortDirections: ["ascend", "descend"],
    },
  };

  const renderHeader = () => (
    <div className="flex flex-col gap-4 mb-5">
      <div className="flex flex-col gap-3 lg:flex-row lg:flex-wrap lg:items-end lg:gap-3">
        <div className="flex gap-2 w-full lg:w-auto">
          <div className="w-1/2 lg:w-auto flex items-center gap-2">
            <span className="text-sm whitespace-nowrap lg:mb-1">Show:</span>
            <Select
              value={typeFilter}
              onChange={setTypeFilter}
              className="flex-1 lg:w-40"
              options={[
                { label: "All", value: "all" },
                { label: "Jobs", value: "jobs" },
                { label: "Locations", value: "locations" },
              ]}
            />
          </div>
          <div className="w-1/2 lg:w-auto flex items-center lg:items-end">
            <Radio.Group
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              optionType="button"
              buttonStyle="solid"
              className="custom-radio-group w-full lg:w-auto"
            >
              <Radio.Button className="w-1/2 lg:w-auto text-center" value="live">
                Live
              </Radio.Button>
              <Radio.Button className="w-1/2 lg:w-auto text-center" value="expired">
                Expired
              </Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <div className="w-[70%] lg:w-64">
          <Search
            placeholder="Search"
            allowClear
            className="w-full lg:w-64"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPaginationState({});
            }}
          />
        </div>
        {status === "expired"&&<div className="flex items-center gap-2 w-[70%] lg:w-auto">
          <span className="text-sm whitespace-nowrap">
            Jobs Posted in Last:
          </span>
          <Select
            value={selectedDays}
            onChange={setSelectedDays}
            options={constants.Days}
            className="flex-1 lg:w-40"
          />
        </div>}
      </div>
    </div>
  );

  const renderTables = () => (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mx-auto">
      {activeKeys.map((key) => {
        const config = TAB_CONFIG[key];
        const data = multiData[key] || [];
        const filtered = data.filter((item) =>
          config.columns.some((colKey) =>
            String(item[commonColumns[colKey].dataIndex] || "")
              .toLowerCase()
              .includes(searchText.toLowerCase())
          )
        );
        return (
          <Card
            className="shadow rounded"
            title={config.label}
            extra={
              <Tooltip title="Download as Excel">
                <Button
                  icon={<FileExcelOutlined />}
                  className="bg-green-800 text-white hover:!text-white hover:!border-green-500"
                  onClick={() => downloadFile(key)}
                  loading={downloadLoading[key]}
                />
              </Tooltip>
            }
          >
            <Table
              columns={config.columns.map((c) => commonColumns[c])}
              dataSource={filtered}
              rowKey="id"
              className='custom-table'
              scroll={{ x: "max-content", y: 500 }}
              pagination={{
                current: paginationState[key]?.current || 1,
                pageSize: paginationState[key]?.pageSize || 10,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100'],
                showTotal: (total, range) =>
                  `${range[0]}-${range[1]} of ${total} records`,
              }}
              onChange={(pagination) => {
                setPaginationState((prev) => ({
                  ...prev,
                  [key]: pagination,
                }));
              }}
              loading={loader[key]}
            />
          </Card>
        );
      })}
    </div>
  );
  const items = [
    {
      key: "highSpend",
      label: "Highest Spend",
    },
    {
      key: "lowVolume",
      label: "Low Application Volume",
    },
  ]
  return (
    <div>
      <Tabs
        activeKey={mainTab}
        onChange={setMainTab}
        items={items}
      />
      {renderHeader()}
      {renderTables()}
    </div>
  );
};
export default SpendData;
